import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import { ValueDifferenceGridItem } from './BorrowingBaseSummaryValueDifferenceGridItem';
import {
  AllBorrowingBaseReportSummaryFields,
  BorrowingBaseSummaryColumnValueInput,
  borrowingBaseSummaryFormatterMap,
  BorrowingBaseSummaryValueType,
  getTemplateColumnsForAccordionRow,
} from './utils';
import { colors } from 'packages/common-frontend/colors';
import { CalculationTerminologiesPopover } from 'packages/resources/ui/CalculationTerminologiesPopover';

export const BorrowingBaseSummaryAccordionSubRow: React.FC<{
  label?: string;
  valueType: BorrowingBaseSummaryValueType;
  columnValues: BorrowingBaseSummaryColumnValueInput;
  showComparisonAndDifferenceColumns: boolean;
  fieldName: AllBorrowingBaseReportSummaryFields;
}> = ({
  label,
  valueType,
  columnValues,
  showComparisonAndDifferenceColumns,
  fieldName,
}) => {
  const formatter = borrowingBaseSummaryFormatterMap[valueType];

  const templateColumns = getTemplateColumnsForAccordionRow({
    showComparisonAndDifferenceColumns,
  });

  // value difference calculation and formatting
  const minuend = columnValues.minuendValue;
  const subtrahend = columnValues.subtrahendValue;

  return (
    <Box backgroundColor={colors.background[50]} borderRadius="8px" mt="8px">
      <Grid minH="48px" templateColumns={templateColumns} gap="16px">
        <GridItem
          colSpan={1}
          alignSelf="center"
          fontSize="16px"
          fontWeight={400}
          color={colors.black[70]}
          whiteSpace="pre-line"
        >
          {label}
          <Box display="inline-block" ml="4px">
            <CalculationTerminologiesPopover termKeyLabel={label} />
          </Box>
        </GridItem>

        {/* If only a single column of values: */}
        {!showComparisonAndDifferenceColumns && (
          <GridItem colSpan={2} alignSelf="center" />
        )}
        {!showComparisonAndDifferenceColumns && (
          <GridItem
            colSpan={2}
            alignSelf="center"
            padding="8px 16px"
            backgroundColor={colors.gray[20]}
          >
            <Text fontSize="16px" fontWeight={600}>
              {formatter(columnValues.minuendValue)}
            </Text>
          </GridItem>
        )}

        {/* If showing all columns of comparison and difference values: */}
        {showComparisonAndDifferenceColumns && (
          <GridItem colSpan={1} alignSelf="center" padding="8px 16px">
            <Text fontSize="16px" textAlign="left" color={colors.black[70]}>
              {formatter(columnValues.referenceValue)}
            </Text>
          </GridItem>
        )}
        {showComparisonAndDifferenceColumns && (
          <GridItem colSpan={1} alignSelf="center" padding="8px 16px">
            <Text fontSize="16px" textAlign="left" color={colors.black[70]}>
              {formatter(columnValues.subtrahendValue)}
            </Text>
          </GridItem>
        )}
        {showComparisonAndDifferenceColumns && (
          <GridItem colSpan={1} alignSelf="center" padding="8px 16px">
            <Text fontSize="16px" textAlign="left" color={colors.black[70]}>
              {formatter(columnValues.minuendValue)}
            </Text>
          </GridItem>
        )}
        {showComparisonAndDifferenceColumns && (
          // Difference column with special formatting
          <ValueDifferenceGridItem
            minuend={minuend}
            subtrahend={subtrahend}
            valueType={valueType}
            fieldName={fieldName}
          />
        )}
      </Grid>
    </Box>
  );
};
